import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import novex from "../../assets/novex.png";
import zilco from "../../assets/zilco.png";
import cavil from "../../assets/cavil.png";
import buraq from "../../assets/buraq.png";
import { useNavigate } from "react-router-dom";   
import CallMadeOutlinedIcon from '@mui/icons-material/CallMadeOutlined';
import BrandsScroll from "../Layout/BrandsScroll";


const paragraphStyle = { hyphens: "auto", wordBreak: "break-word" };

const Brands = ({ t }) => {
  const navigate = useNavigate();
  const logos = [
    { src: novex, alt: "Novex" },
    { src: cavil, alt: "Cavil" },
    { src: buraq, alt: "Buraq" },
    { src: zilco, alt: "Zilco" },
  ];

  const data = [
    {
      image: novex,
      title: t("about_us.novex") , 
      desc: t("about_us.novex_des")  ,
      className: "h-10 w-auto",
      links: '/brand/novex'
    },
    {
      image: zilco,
      title: t("about_us.zilco") ,
      desc: t("about_us.zilco_des") ,
      className: "h-11 w-auto",
      links: '/brand/zilco'

    },
    {
      image: cavil,
      title: t("about_us.cavil") ,
      desc:  t("about_us.cavil_des") ,
      className: "h-10 w-auto",
      links: '/brand/cavil'
    },
    {
      image: buraq,
      title:  t("about_us.buraq") ,
      desc: t("about_us.buraq_des") ,
      className: "h-9 w-auto",
      links: '/brand/buraq'
    },
  ];



  return (
    <Box className="w-full py-10  bg-gray-100 p-2 ">
      {/* Header */}
      <BrandsScroll/>

      <Box className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 md:p-16 gap-6 mx-auto">
        {data.map((item, index) => (
          <Box
            key={index}
            className="bg-white rounded-2xl md:p-14 sm:p-4 p-6 shadow-sm flex flex-col items-left"
          >
       
            {/* CONTENT (left aligned but centered block) */}
            <div className="w-full max-w-2xl text-left">
              <Typography className="text-2xl font-semibold text-[#2E2E2E] mb-3 poppins">
                {item.title}
              </Typography>

              <Typography className="text-gray-500 md:text-md lg:text-md text-sm mt-5 text-base leading-relaxed poppins ">
                {item.desc}
              </Typography>
            </div>
                
           <div className="mt-6">
        <button
          onClick={() => navigate(item.links)}
          className="px-5 py-1 text-gray-800 border border-gray-800 hover:bg-gray-900 hover:text-white rounded-lg md:text-md lg:text-md text-sm transition"
        >
           {t("about_us.view")} {item.title}<CallMadeOutlinedIcon className="text-md mb-1 ml-2"/>
        </button>
      </div>


          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Brands;
